<form
  [formGroup]='userProfileForm'
  data-testid="user-profile-form"
>

  <ct-profile>

    <!-- FIRST_NAME -->
    <mat-form-field rsAddClearFormFieldButton>
      <mat-label>{{ 'FIRST_NAME' | translate }}</mat-label>
      <input
        formControlName='firstName'
        matInput
        maxlength='29'
      />
      @if (userProfileForm.controls.firstName.hasError('required')) {
      <mat-error data-testid='firstname-error-required'>
        {{ 'ERROR_MSG.REQUIRED_FIELD' | translate }}
      </mat-error>
      }
    </mat-form-field>

    <!-- LAST_NAME -->
    <mat-form-field rsAddClearFormFieldButton>
      <mat-label>{{ 'LAST_NAME' | translate }}</mat-label>
      <input
        formControlName='lastName'
        matInput
        maxlength='30'
      />
      @if (userProfileForm.controls.lastName.hasError('required')) {
      <mat-error data-testid='lastname-error-required'>
        {{ 'ERROR_MSG.REQUIRED_FIELD' | translate }}
      </mat-error>
      }
    </mat-form-field>

    <!-- JOB_TITLE -->
    <mat-form-field rsAddClearFormFieldButton>
      <mat-label>{{ 'JOB_TITLE' | translate }}</mat-label>
      <input
        formControlName='jobTitle'
        matInput
      />
    </mat-form-field>

    <!-- EMAIL ( CAN BE DISABLED ) -->
    <mat-form-field id='mat-form-field-email'>
      <mat-label>{{ 'EMAIL' | translate }}</mat-label>
      <input
        formControlName='email'
        matInput
        type='email'
      >
      @if (userProfileForm.controls.email.hasError('impersonalEmail')) {
      <mat-error>
        {{ 'IMPERSONAL_EMAIL_ERROR' | translate }}
      </mat-error>
      }

      @if (userProfileForm.controls.email.hasError('email')) {
      <mat-error>
        {{ 'FORM_ERRORS.EMAIL_VALID' | translate }}
      </mat-error>
      }
    </mat-form-field>

    <!-- PHONE -->
    <mat-form-field rsAddClearFormFieldButton>
      <mat-label>{{ 'PHONE' | translate }}</mat-label>
      <input
        formControlName='phone'
        matInput
        maxlength='20'
      />

      @if (userProfileForm.controls.phone.hasError('pattern')) {
      <mat-error data-testid='phone-error-invalid-format'>
        {{ 'FORM_ERRORS.INVALID_PHONE_FORMAT' | translate }}
      </mat-error>
      }
    </mat-form-field>

    <!-- MOBILE -->
    <mat-form-field rsAddClearFormFieldButton>
      <mat-label>{{ 'MOBILE' | translate }}</mat-label>
      <input
        formControlName='mobile'
        matInput
        maxlength='20'
      />

      @if (userProfileForm.controls.mobile.hasError('pattern')) {
      <mat-error data-testid='mobile-error-invalid-format'>
        {{ 'FORM_ERRORS.INVALID_PHONE_FORMAT' | translate }}
      </mat-error>
      }
    </mat-form-field>

    <!-- LANGUAGE -->
    <mat-form-field rsAddClearFormFieldButton>

      <mat-label>{{ "LANGUAGE" | translate }}</mat-label>

      <mat-select formControlName='language'>
        @for (language of languages; track language) {
        <mat-option [value]='language.short'>
          {{ language.apiLong | translate }}
        </mat-option>
        }
      </mat-select>

      @if (userProfileForm.controls.language.hasError('required')) {
      <mat-error data-testid='language-error-required'>
        {{ 'ERROR_MSG.REQUIRED_FIELD' | translate }}
      </mat-error>
      }
    </mat-form-field>

  </ct-profile>

  @if (showAuthorizedRepresentative()) {
  <ct-authorized-representative-block>

    <ct-authorized-representative>
      <div>
        <h2>{{ 'AUTHORIZED_REPRESENTATIVE' | translate }}</h2>
        <a
          mat-button
          (click)="openAuthorizedRepresentativeDialog()"
        >{{ 'LEARN_MORE' | translate }}</a>
      </div>

      <ct-description>
        {{ 'AUTHORIZED_REPRESENTATIVE_DESCRIPTION' | translate }}
      </ct-description>
    </ct-authorized-representative>

    <mat-radio-group formControlName="isLegalRepresentative">
      <mat-radio-button [value]="true">{{ 'I_AM_THE_REPRESENTATIVE' | translate }}</mat-radio-button>
      <mat-radio-button [value]="false">{{ 'I_AM_NOT_THE_REPRESENTATIVE' | translate }}</mat-radio-button>
    </mat-radio-group>

    @if (!isLegalRepresentative()) {
    <mat-form-field rsAddClearFormFieldButton>
      <mat-label>{{ 'EMAIL_REPRESENTATIVE' | translate }}</mat-label>
      <input
        formControlName='legalRepresentativeEmail'
        matInput
      />

      @if (userProfileForm.controls.legalRepresentativeEmail.hasError('required')) {
      <mat-error data-testid='sendRSIEmail-error-required'>
        {{ 'ERROR_MSG.REQUIRED_FIELD' | translate }}
      </mat-error>
      }

      @if (userProfileForm.controls.legalRepresentativeEmail.hasError('email')) {
      <mat-error>
        {{ 'FORM_ERRORS.EMAIL_VALID' | translate }}
      </mat-error>
      }
    </mat-form-field>
    }

    <ct-invoicing-contact>
      <h2>{{ "INVOICING_CONTACT" | translate }}</h2>
      <ct-description>{{ 'INVOICING_CONTACT_DESCRIPTION' | translate }}</ct-description>
    </ct-invoicing-contact>

    <mat-form-field rsAddClearFormFieldButton>
      <mat-label>{{ 'INVOICE_EMAIL' | translate }}</mat-label>
      <input
        formControlName='sendRSIEmail'
        matInput
      />

      @if (userProfileForm.controls.sendRSIEmail.hasError('required')) {
      <mat-error data-testid='sendRSIEmail-error-required'>
        {{ 'ERROR_MSG.REQUIRED_FIELD' | translate }}
      </mat-error>
      }

      @if (userProfileForm.controls.sendRSIEmail.hasError('email')) {
      <mat-error>
        {{ 'FORM_ERRORS.EMAIL_VALID' | translate }}
      </mat-error>
      }
    </mat-form-field>

  </ct-authorized-representative-block>
  }

</form>